import { AlternativeCultureUrl } from "@obg/ngx.core";

import { Flag } from "./flag.model";

interface GetHrefArgs {
	flag: Flag;
	alternativeCultureUrl: AlternativeCultureUrl | undefined;
	fallbackHref: string;
}

export namespace FlagUtil {
	export function getAlternativeCultureUrl(
		flag: Flag,
		alternativeCultureUrls: AlternativeCultureUrl[]
	): AlternativeCultureUrl | undefined {
		return alternativeCultureUrls.find((altCultureUrl) => {
			if (
				flag.languageCode === "eu" &&
				flag.countryCode === "EU" &&
				`en-GB` === altCultureUrl.culture &&
				altCultureUrl.languageCode === "eu"
			) {
				return true;
			}
			if (flag.languageCode === "no" && flag.countryCode === "NO" && `nb-NO` === altCultureUrl.culture) {
				return true;
			}
			if (flag.languageCode === "pe" && flag.countryCode === "pe" && `es-PE` === altCultureUrl.culture) {
				return true;
			}
			if (flag.languageCode === "cl" && flag.countryCode === "CL" && `es-CL` === altCultureUrl.culture) {
				return true;
			}
			if (flag.languageCode === "br" && flag.countryCode === "BR" && `pt-BR` === altCultureUrl.culture) {
				return true;
			}
			if (
				["en-GB", "es-PE"].includes(altCultureUrl.culture) &&
				altCultureUrl.languageCode !== flag.languageCode
			) {
				return false;
			}
			return `${flag.languageCode}-${flag.countryCode}`.toLowerCase() === altCultureUrl.culture.toLowerCase();
		});
	}

	export function getHref(args: GetHrefArgs): string {
		const { flag, alternativeCultureUrl, fallbackHref } = args;
		const href = flag.link.url || alternativeCultureUrl?.url || `${fallbackHref}/${flag.marketCode}`;

		return href;
	}

	export function addQueryParamsToHref(href: string, queryParams: Record<string, any>): string {
		const urlSearchParams = new URLSearchParams(queryParams).toString();
		const queryParamsForHref = urlSearchParams ? `?${urlSearchParams}` : "";

		return `${href}${queryParamsForHref}`;
	}

	export function isExternalDomain(flag: Flag): boolean {
		/* flag.link.url is set by CRS for external domains */
		return !!flag.link.url;
	}

	export function appendRouteParamsToFlags(flags: Flag[], params: string[]): Flag[] {
		return flags.map((flag) => {
			const href = flag.href;
			if (!params.length || FlagUtil.isExternalDomain(flag) || !href) {
				return flag;
			}

			const updatedHref = href.includes("?")
				? href.replace("?", `/${params.join("/")}?`)
				: `${href}/${params.join("/")}`;

			return { ...flag, href: updatedHref };
		});
	}
}
